export default {"src":"/uk/_next/static/media/manage.5192afa1.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};